import { cn } from '@/shared/lib/utils'

function ShimmerBlock({ className }) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-lg bg-gradient-to-r from-slate-100 via-slate-200/80 to-slate-100 bg-[length:200%_100%]',
        className,
      )}
    />
  )
}

function CardShell({ children, className }) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-black/[0.06] bg-white p-5 shadow-[0_8px_24px_rgba(15,23,42,0.04)]',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default function SalesDashboardShimmer() {
  return (
    <div
      className="flex flex-col gap-4 sm:gap-5"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex justify-end">
        <ShimmerBlock className="h-9 w-28 rounded-full" />
      </div>

      <ShimmerBlock className="h-[88px] w-full rounded-[24px] sm:h-[100px]" />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {Array.from({ length: 5 }).map((_, index) => (
          <CardShell key={index}>
            <ShimmerBlock className="h-3.5 w-28" />
            <ShimmerBlock className="mt-4 h-10 w-16" />
            <ShimmerBlock className="mt-2 h-3 w-36" />
            <div className="mt-5 space-y-3">
              {Array.from({ length: 3 }).map((__, row) => (
                <div key={row} className="flex items-center gap-2">
                  <ShimmerBlock className="size-2 rounded-full" />
                  <ShimmerBlock className="h-3 w-28" />
                </div>
              ))}
            </div>
          </CardShell>
        ))}
      </div>

      <div className="grid items-stretch gap-4 xl:grid-cols-[minmax(280px,340px)_1fr]">
        <CardShell>
          <div className="mb-4 flex justify-between">
            <div className="space-y-2">
              <ShimmerBlock className="h-4 w-40" />
              <ShimmerBlock className="h-3 w-32" />
            </div>
            <ShimmerBlock className="size-7 rounded-md" />
          </div>
          <div className="mt-4 flex gap-2">
            <ShimmerBlock className="h-7 w-16 rounded-full" />
            <ShimmerBlock className="h-7 w-16 rounded-full" />
            <ShimmerBlock className="h-7 w-20 rounded-full" />
          </div>
          <div className="mt-5 space-y-4">
            {Array.from({ length: 4 }).map((_, row) => (
              <div key={row} className="space-y-1.5">
                <div className="flex justify-between">
                  <ShimmerBlock className="h-3 w-20" />
                  <ShimmerBlock className="h-3 w-12" />
                </div>
                <ShimmerBlock className="h-1.5 w-full rounded-full" />
              </div>
            ))}
          </div>
        </CardShell>

        <CardShell className="border-amber-200/80 bg-amber-50/40">
          <div className="flex items-center gap-2">
            <ShimmerBlock className="size-2.5 rounded-full" />
            <ShimmerBlock className="h-4 w-44" />
            <ShimmerBlock className="size-5 rounded-full" />
          </div>
          <ShimmerBlock className="mt-2 h-3 w-52" />
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {Array.from({ length: 4 }).map((_, row) => (
              <div
                key={row}
                className="flex items-center gap-3 rounded-[14px] border border-slate-100 bg-white p-3"
              >
                <ShimmerBlock className="size-9 shrink-0 rounded-full" />
                <div className="min-w-0 flex-1 space-y-2">
                  <ShimmerBlock className="h-3 w-24" />
                  <ShimmerBlock className="h-2.5 w-32" />
                </div>
                <ShimmerBlock className="h-6 w-16 rounded-full" />
              </div>
            ))}
          </div>
        </CardShell>
      </div>
    </div>
  )
}
